import React, { useEffect, useState } from "react";
import "antd/dist/antd.css";
import styles from "./GeoIp.module.css";
import {
  Button,
  Card,
  Col,
  Empty,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
  Tag,
  Table,
  Tooltip,
  Typography,
} from "antd";
import { fetchGeoIp } from "../../api";
import { getNextMonday } from "../../api/util";
const { Text, Title } = Typography;

const GeoIp = () => {
  const [inp, setInp] = useState(null);
  const [rel, setRel] = useState(null);
  const [ipData, setIpData] = useState(null);
  const [load, setLoad] = useState(true);
  const [submit, setSubmit] = useState(false);
  useEffect(() => {
    if (!rel) {
      fetchData();
    }
  }, [rel]);

  const fetchData = async () => {
    setLoad(true);
    const version = await fetchGeoIp({ uri: "version" });

    if (!version["data"]["res"]["error"] && version["data"]["res"]["version"]) {
      const arrL = version["data"]["res"]["version"]
        ? version["data"]["res"]["version"]
            .sort((a, b) => {
              return b.localeCompare(a, undefined, {
                numeric: true,
                sensitivity: "base",
              });
            })
            .map((x, ind) => {
              return {
                value: x,
                label: x != "develop" ? "Release " + x : "Upcoming",
                // : x[0].toUpperCase() + x.slice(1),
              };
            })
        : [];
      arrL.unshift({ value: "all", label: "All Releases" });
      setRel(arrL);
    } else {
      message.info("geoipdb under maintenance");
    }

    setLoad(false);
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const onFinish = async (value) => {
    setSubmit(false);
    console.log("Success:", value);
    const ip = await fetchGeoIp({
      // ip: "190.1.1.1",
      ip: value.ip,
      version: "all",
      uri: "geoiplookup",
    });

    if (!ip["data"]["res"]["error"] && ip["data"]["res"]["data"]) {
      const keys = Object.keys(ip["data"]["res"]["data"]);

      setIpData(
        ip["data"]["res"]["data"] && ip["data"]["res"]["data"].length > 0
          ? ip["data"]["res"]["data"]
              .sort((a, b) => {
                return b["Release"].localeCompare(a["Release"], undefined, {
                  numeric: true,
                  sensitivity: "base",
                });
              })
              .map((x, ind) => {
                x["key_id"] = ind;
                return x;
              })
          : []
      );

      value.select && value.select.includes("all")
        ? setInp({
            ip: value.ip,
            version: [
              ...new Set(ip["data"]["res"]["data"].map((x) => x.Release)),
            ],
          })
        : setInp({
            ip: value.ip,
            version: value.select,
          });
      setSubmit(true);
    } else {
      setInp({
        ip: value.ip,
        version: value.select,
      });
      setIpData([{ Verdict: "no geoip data found" }]);
      setSubmit(true);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div>
      {/* date range filter */}
      <Row type="flex" style={{ margin: "5px", padding: "1px" }}>
        <Col className="gutter-row" span={1}></Col>
        <Col className="gutter-row" span={15}>
          <Card
            bordered={false}
            style={{ height: 91, margin: "1px", padding: "1px" }}
            bodyStyle={{ padding: "0" }}
          >
            <>
              <Row>
                <Text style={{ paddingLeft: "6px", marginBottom: "1px" }}>
                  IP Lookup
                </Text>
              </Row>

              <ColoredLine color={"lightgrey"} />

              <Row style={{ margin: "4px", marginLeft: "8px" }}>
                <Col>
                  <Form
                    name="basic"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    initialValues={{
                      select: "all",
                    }}
                  >
                    <Space>
                      <Form.Item
                        name="ip"
                        rules={[
                          {
                            required: true,
                            message: "Please input IP!",
                          },
                        ]}
                      >
                        {/* <Input /> */}
                        <Input
                          name="Input"
                          style={{ width: "30em" }}
                          placeholder="Enter Ip"
                        />
                      </Form.Item>

                      <Form.Item
                        name="select"
                        rules={[
                          {
                            required: true,
                            message: "Please select a version",
                          },
                        ]}
                      >
                        <Select
                          mode="multiple"
                          size={"middle"}
                          placeholder="Please select"
                          defaultValue={["all"]}
                          onChange={handleChange}
                          style={{
                            width: "20em",
                          }}
                          options={rel}
                          maxTagCount="responsive"
                        />
                      </Form.Item>

                      <Form.Item>
                        <Button type="primary" htmlType="submit">
                          Search
                        </Button>
                      </Form.Item>
                    </Space>
                  </Form>
                </Col>
              </Row>
            </>
          </Card>
        </Col>
      </Row>
      {/* data */}
      <IpData submit={submit} ipData={ipData} inp={inp} />
    </div>
  );
};

const IpData = (props) => {
  return (
    <>
      {props.submit &&
      props.ipData.length > 0 &&
      props.ipData[0]["Verdict"] != "no geoip data found" ? (
        props.inp.version.map((x, ind) => (
          <Row key={ind} type="flex" style={{ margin: "5px", padding: "1px" }}>
            <Col className="gutter-row" span={1}></Col>
            <Col className="gutter-row" span={22}>
              <Card bordered={false} style={{ margin: "1px", padding: "1px" }}>
                <Row>
                  <Col span={18}>
                    <Text
                      style={{
                        paddingLeft: "6px",
                        marginBottom: "1px",
                      }}
                      strong
                    >
                      {x != "develop"
                        ? "Release " + x + " : " + props.inp.ip
                        : "Upcoming" +
                          // : x[0].toUpperCase() +  x.slice(1) +
                          " : " +
                          props.inp.ip}
                    </Text>
                  </Col>
                  <Col span={6}>
                    {x == "develop" ? (
                      <Tooltip
                        placement="topLeft"
                        title={
                          "Please reach-out to 'geoipdb-weekly-deployment' channel for exact deployment date and time."
                        }
                      >
                        {
                          <Text style={{ color: "#2986F7" }}>
                            Tentative deployment date: {getNextMonday()}
                          </Text>
                        }
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>

                <ColoredLine color={"lightgrey"} />

                <Table
                  rowKey={"key_id"}
                  columns={columns}
                  dataSource={props.ipData.filter((y) => y.Release === x)}
                  pagination={false}
                />
              </Card>
            </Col>
          </Row>
        ))
      ) : props.submit &&
        props.ipData[0]["Verdict"] == "no geoip data found" ? (
        <>
          {[1, 2, 3, 4].map((x, ind) => (
            <br key={ind} />
          ))}
          <Empty
            description={"Geo location data not found for IP: " + props.inp.ip}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

const ColoredLine = ({ color }) => (
  <hr
    style={{
      border: "none",
      marginLeft: "6px",
      marginRight: "6px",
      height: "0.08px",
      color: color,
      backgroundColor: color,
    }}
  />
);

const columns = [
  {
    title: "Vendor",
    dataIndex: "Vendor",
    key: "Vendor",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "Country",
    dataIndex: "Country",
    key: "Country",
  },
  {
    title: "Latitude",
    dataIndex: "Latitude",
    key: "Latitude",
  },
  {
    title: "Location",
    dataIndex: "Location",
    key: "Location",
  },
  {
    title: "Longitude",
    dataIndex: "Longitude",
    key: "Longitude",
  },
  {
    title: "Region",
    dataIndex: "Region",
    key: "Region",
  },
  {
    title: "Timezone",
    dataIndex: "Timezone",
    key: "Timezone",
  },
  {
    title: () => (
      <Tooltip
        placement="bottomRight"
        title={"Vendor used by GeoIP DB package for final output."}
      >
        Verdict
      </Tooltip>
    ),
    dataIndex: "Verdict",
    key: "Verdict",
  },
];

export default GeoIp;
